import { routes } from '@/app/routing/router'
import { ExternalUnifiedProfileView } from './view'
const currentRoute = routes.externalUnifiedProfile

const ExternalUnifiedProfileRoute = {
  route: currentRoute,
  view: ExternalUnifiedProfileView,
}

export { currentRoute, ExternalUnifiedProfileRoute }
